module.exports = __webpack_public_path__ + "static/media/configuracion_white.ef9eb55b.svg";